import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
// import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import QtyInput from '../../Shared/QtyInput'
// import ConvertQuantity from '../../Shared/ConvertQuantity'
// import NumberFormat from 'react-number-format'
// import measurementTypes from '../../../_constants/measurementTypes'
// import { MdClose } from 'react-icons/md'
// import { GoPlus } from 'react-icons/go'
// import Fab from '@material-ui/core/Fab'
// import { DecimalInput } from 'react-hichestan-numberinput'

// const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

function calculateInputsQuantity(product, outputQuantity) {
  let res = 0

  if (product.categoryId === 'fb22675d-c9cd-41a3-ac7a-6f9274cd152a') {
    res = outputQuantity * product.numberOfParts || 0
  }

  return res > 0 ? res : 0
}

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>اطلاعات کالای تولید شده</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">مقدار تولید سالم</th>
                {/* <th className="text-center">ضایعات</th> */}
              </tr>
            </thead>
            <tbody>
              {values.outputs &&
                values.outputs.map((item, index) => (
                  <tr key={'p-' + index}>
                    <td>{index + 1}</td>
                    <td>
                      {values.outputs[index].product &&
                        values.outputs[index].product.category.name}
                    </td>
                    <td>
                      {values.outputs[index].product &&
                        values.outputs[index].product.brand.name}
                    </td>
                    <td>
                      {values.outputs[index].product &&
                        values.outputs[index].product.name}
                    </td>
                    <td>
                      <QtyInput
                        disabled={
                          values.outputs[index].product &&
                          values.outputs[index].product.conversionUnit
                        }
                        measurementType={
                          values.outputs[index].product &&
                          values.outputs[index].product.measurementType
                        }
                        subMeasurementType={
                          values.outputs[index].product &&
                          values.outputs[index].product.subMeasurementType
                        }
                        conversionUnit={
                          values.outputs[index].product &&
                          values.outputs[index].product.conversionUnit
                        }
                        onChange={(val, subVal) => {
                          setFieldValue(`outputs[${index}][quantity]`, val)
                          setFieldValue(
                            `outputs[${index}][subQuantity]`,
                            subVal
                          )

                          let currentProduct = values.outputs[index].product
                          console.log(currentProduct)
                          if (currentProduct.category.categoryClass === 0) {
                            let inputProductIndex = values.items.findIndex(
                              el =>
                                el.product.categoryId ===
                                  '993568e7-dbba-4419-968d-319fcdc10bc9' &&
                                el.product.brandId === currentProduct.brandId
                            )

                            setFieldValue(
                              `items[${inputProductIndex}][quantity]`,
                              subVal
                            )
                          } else if (
                            currentProduct.category.categoryClass === 1
                          ) {
                            let inputProductIndex = values.items.findIndex(
                              el =>
                                el.product.categoryId ===
                                  '993568e7-dbba-4419-968d-319fcdc10bc9' &&
                                el.product.brandId !== currentProduct.brandId
                            )

                            setFieldValue(
                              `items[${inputProductIndex}][quantity]`,
                              subVal
                            )
                          } else if (
                            currentProduct.category.categoryClass === 2
                          ) {
                            // let inputProductIndex = values.items.findIndex(
                            //   el =>
                            //     el.productId ===
                            //     'ec9efb33-1003-4f24-bb5b-d77d6be8d601'
                            // )
                            // let no =
                            //   values.items[inputProductIndex].product
                            //     .numberOfParts || 1
                            // setFieldValue(
                            //   `items[${inputProductIndex}][quantity]`,
                            //   subVal / no
                            // )
                          }

                          //پیدا کردن ایندکس تایل برش شده
                          let inputProductIndex = values.items.findIndex(
                            el =>
                              el.product.categoryId ===
                              'fb22675d-c9cd-41a3-ac7a-6f9274cd152a'
                          )

                          if (inputProductIndex > -1) {
                            let boxIndex = values.items.findIndex(
                              el =>
                                el.product.categoryId ===
                                  '993568e7-dbba-4419-968d-319fcdc10bc9' &&
                                el.product.brandId !== currentProduct.brandId
                            )

                            if (boxIndex > -1) {
                              let numberOfParts =
                                values.items[boxIndex].product.numberOfParts

                              if (currentProduct.measurementType === 0) {
                                subVal = subVal * numberOfParts
                              }

                              let otherOutputs = values.outputs.filter(
                                el =>
                                  el.productId !==
                                  values.outputs[index].productId
                              )

                              let finalQuantity = subVal

                              otherOutputs.forEach(output => {
                                let subQountity = output.subQuantity || 0
                                if (output.product.measurementType === 0) {
                                  finalQuantity += subQountity * numberOfParts
                                } else if (
                                  output.product.measurementType === 5
                                ) {
                                  finalQuantity += subQountity
                                }
                              })

                              setFieldValue(
                                `items[${inputProductIndex}][quantity]`,
                                finalQuantity
                              )
                            }
                          }

                          // values.outputs.forEach(output => {

                          //   values.inputs.forEach(input => {

                          //   });

                          // });
                        }}
                        value={values.outputs[index].quantity}
                      />
                      <ErrorMessage
                        component={ErrorPopUp}
                        name={`outputs[${index}].quantity`}
                      />
                    </td>
                    {/* <td>
                    {values.outputs[index].product && values.outputs[index].product.conversionUnit ?
                      <QtyInput
                        disabled={values.outputs[index].product && values.outputs[index].product.conversionUnit && values.outputs[index].product.measurementType != values.outputs[index].product.subMeasurementType}
                        measurementType={values.outputs[index].product && values.outputs[index].product.measurementType}
                        subMeasurementType={values.outputs[index].product && values.outputs[index].product.subMeasurementType}
                        conversionUnit={values.outputs[index].product && values.outputs[index].product.conversionUnit}
                        onChange={(val, subVal) => {

                          if (val) {

                            // if (waste <= values.outputs[index].unitProductQuantity) {
                            setFieldValue(`outputs[${index}][waste]`, val)
                            // } else {
                            //   setFieldValue(`outputs[${index}][waste]`, undefined)
                            //   setFieldValue(`outputs[${index}][subWaste]`, undefined)
                            // }

                          } else {
                            setFieldValue(`outputs[${index}][waste]`, undefined)
                          }

                          setFieldValue(`outputs[${index}][subWaste]`, subVal)

                        }}
                        value={values.outputs[index].subWaste}
                      />
                      : ''}
                    <ErrorMessage component={ErrorPopUp} name={`outputs[${index}].waste`} />
                  </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>
  </>
)
